module.exports = __webpack_public_path__ + "assets/img/9e8fe7adf3b2748895d66479c9929920.png";